import useAppContext from '/business/shared/hooks/useAppContext';

import StyledDisabledOverlay from './__styled__/StyledDisabledOverlay';

function DisabledOverlay() {
  const { isAppDisabled } = useAppContext();

  if (isAppDisabled) {
    return <StyledDisabledOverlay />;
  }

  return null;
}

export default DisabledOverlay;
